import { requireNotNull } from "@enymo/ts-nullsafe";
import React from "react";
import { createRoot } from "react-dom/client";
import Bootstrapper from "./Bootstrapper";
import "./common";

createRoot(requireNotNull(document.getElementById("app"))).render(<Bootstrapper />);